var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8954 3.09948C11.7634 3.09948 11.6326 3.12548 11.5107 3.176C11.3887 3.22651 11.2779 3.30055 11.1846 3.39389L3.86632 10.7122L3.33326 12.6667L5.28784 12.1337L12.6061 4.8154C12.6995 4.72206 12.7735 4.61125 12.824 4.4893C12.8745 4.36735 12.9005 4.23665 12.9005 4.10464C12.9005 3.97264 12.8745 3.84194 12.824 3.71999C12.7735 3.59803 12.6995 3.48723 12.6061 3.39389C12.5128 3.30055 12.402 3.22651 12.28 3.176C12.1581 3.12548 12.0274 3.09948 11.8954 3.09948ZM11.0899 2.16021C11.3453 2.05444 11.619 2 11.8954 2C12.1717 2 12.4454 2.05444 12.7008 2.16021C12.9561 2.26597 13.1881 2.421 13.3836 2.61644C13.579 2.81187 13.734 3.04388 13.8398 3.29923C13.9456 3.55458 14 3.82826 14 4.10464C14 4.38103 13.9456 4.65471 13.8398 4.91006C13.734 5.1654 13.579 5.39742 13.3836 5.59285L5.96206 13.0144C5.89441 13.082 5.81028 13.1308 5.71798 13.156L2.6944 13.9806C2.50407 14.0325 2.30053 13.9785 2.16103 13.839C2.02153 13.6995 1.96748 13.4959 2.01938 13.3056L2.844 10.282C2.86917 10.1897 2.91799 10.1056 2.98564 10.0379L10.4071 2.61644C10.6026 2.421 10.8346 2.26597 11.0899 2.16021Z",
    fill: "#8927EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.a510f002fcdfb0daaaa51e42abfd4901.svg";
export { ForwardRef as ReactComponent };